import React from 'react'
import BlogPostSection from '../components/BlogPostSection'
import Navbar from '../components/Navbar'
import ProjectsHeader from '../components/ProjectsHeader'
import { allBlogPostDicts } from '../content/allContent'
import { navbarHeight } from '../App';
import Footer from '../components/Footer';
import ReactGA from 'react-ga4';

const Blog = ({ theme, setTheme }) => {

  ReactGA.send({ hitType: "pageview", page: "/blog", title: "BlogPageViews" });

  return (
    <div className='bg-light dark:bg-dark dark:text-light cursor-auto'>
      <Navbar theme={theme} setTheme={setTheme}/>
      <div className="p-4 min-h-screen" style={{paddingTop: navbarHeight}}>
        <div className="m-auto max-w-3xl">
          <ProjectsHeader title={"Blog"} subtitle={"I write about Machine Learning topics while I learn about them myself."}/>
          {
            allBlogPostDicts.map((blogPostDict, idx) => {
              return <BlogPostSection key={idx} contentDict={blogPostDict}/>
            })
          }
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default Blog